//TODO : 
// refresh
// Date format in Form

import React from 'react';
import Moment from 'react-moment';
import { CardMedium } from '../../widgets/Cards';
import Modal from '../../widgets/Modal';
import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
import { fetchMedications, fetchMedication, editMedication, newMedication, deleteMedication} from '../../../actions';
import { Form, Field} from 'react-final-form';

class Medication extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchMedications(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchMedications(this.props.patient._id)
        }
        
    }

    compareDate(a, b) {

        var key1 = a.prescriptiondate;
        var key2 = b.prescriptiondate;
    
        if (key1 < key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }

    renderMedicationList() {


        var list = this.props.medications;
        var sortedList = list.sort(this.compareDate);

        return sortedList.map(med =>  {
            
            return (
                    <tr key={med._id}>
                        <td>{med.product}</td>
                        <td>{med.content}</td>
                        <td>{med.dose }</td>
                        <td>{med.frequency }</td>
                        <td>{med.route }</td>
                        <td>{med.prn }</td>
                        <td>{med.prescriber }</td>
                        <td> <Moment format='DD MMM YYYY'>{med.prescriptiondate}</Moment></td>
               
                    </tr>
            )
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].chronicdisease;
        console.log(permit);
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} className='btnew'>Add</button>
        }  
    }

    render() {
        return (
        
                <CardMedium title='Medications' buttons={this.buttons()}>
                    <table>
                        <thead>
                            <tr>
                                <th>Medication</th>
                                <th>Content</th>
                                <th>Dose</th>
                                <th>Freq</th>   
                                <th>Route</th>
                                <th>PRN</th>
                                <th>Prescriber</th>
                                <th>Date Prescribed</th>
                          
                            </tr>
                        </thead>
                        <tbody> 
                            {this.renderMedicationList()}
                        </tbody> 
                    </table>
                    
                {this.renderModalBox()}
                {this.renderDeleteBox()}
                </CardMedium>

           
     

        )
    }

    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deleteMedication(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

        return (
            <Confirm
                height='100px'
                width='300px'
                open={this.state.showDelete} 
                data={this.state.record}
                content="Delete this medication?"
                title='Delete Medication'
                actions = {deleteButtons()}
                onDismiss={() => this.setState({showDelete : false, record:null})}
            />
        )

    }

    
    renderModalBox() {
        const record = this.state.record;
        if (record !== null) {
           this.props.fetchMedication(record);
        }

        //content of the Modal Box

        const medicationForm = () => {
            const required = value =>(value ? undefined : 'Required');
         
            var content;
            if (this.state.newForm === false ) {
                content = this.props.selectedMedication;
            } else {
                content = null;
            }
            const currentMed = content;

            const handleSubmit = (formValues) => {
            
                const form = formValues;
                form['patientId'] = this.props.patient._id;
                form['userId'] = this.props.userId;  

                const medId = form._id;
                if (medId === undefined) {
                    this.props.newMedication(form);
                } else {
                    this.props.editMedication(form, medId);
                }
                this.setState({showModal :false, newForm : true,record : null,});
           }

            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    initialValues = {currentMed}
                    render = {({ handleSubmit, pristine, form, values, submitting }) => {
                    return   (
                            <form onSubmit={handleSubmit}>
                                    <Field name="product" component='input' validate={required} placeholder='Enter Medication Name'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Medication</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="content" component='input' validate={required} placeholder='Enter content'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Content</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name='dose'  validate={required}  placeholder='Enter dose'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Dose</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="frequency" component='input'>
                                        {({ input}) => (
                                            <div>
                                                <label>Frequency</label>
                                                <select {...input}>
                                                    <option value="Once daily">Once daily</option>
                                                    <option value="Twice daily">Twice daily</option>
                                                    <option value="Three times a day">Three times a day</option>
                                                    <option value="Four times a day">Four times a day</option>
                                                    <option value="Every 4 hours">every 4 hours</option>
                                                    <option value="Every 8 hours">every 8 hours</option>
                                                    <option value="Every 12 hours">ever 12 hours</option>
                                                    <option value="Once a week">Once a week</option>
                                                    <option value="Twice a week">Twice a week</option>
                                                    <option value="Once a month">Once a month</option>
                                                    <option value="Once every 3 months">Once every 3 months</option>
                                                    <option value="Once every 6 months">Once every 6 months</option>
                                                </select>
                                            </div>
                                    )}
                                    </Field>
                                    <Field name="route" component='input'>
                                        {({ input}) => (
                                            <div>
                                                <label>Route</label>
                                                <select {...input}>
                                                    <option value="Per oral">Per oral</option>
                                                    <option value="Sublingual">Sublingual</option>
                                                    <optino value="Eye drop">Eye drop</optino>
                                                    <option value="Nasal spray">Nasal Spray</option>
                                                    <option value="Topical">Topical</option>
                                                    <option value="Inhaler">Inhaler</option>
                                                    <option value="Nebulizer">Nebulizer</option>
                                                    <option value="Subcutaneous">Subcutaneous</option>
                                                    <option value="Intra venous">Intra Venous</option>
                                                    <option value="Intra Muscular">Intra Muscular</option>
                                                
                                                </select>
                                            </div>
                                    )}
                                    </Field>
                                    <Field name='prn'  validate={required}  placeholder='regular or PRN'>
                                        {({input, meta, placeholder}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Reg/PRN</label>
                                                    <input {...input} placeholder={placeholder} />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                            )}
                                    </Field>       
                                    <Field name='prescriber'  validate={required}  placeholder='Prescriber'>
                                        {({input, meta, placeholder}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Prescriber</label>
                                                    <input {...input} placeholder={placeholder} />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                            )}
                                    </Field>  
                                    <Field name='prescriptiondate'  validate={required} placeholder='Enter date'>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Date Prescribed</label>
                                                    <input {...input} type='date' />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                            )}
                                    </Field>
                                    <div className='modalButton'>
                                        <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                        <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                        <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                                    </div>
                            </form>
                        )
                    }}
                />
            )
        }   
        //  <pre>{JSON.stringify(values, 0, 2)}</pre>

// main render
        return (
            <Modal 
                height='440px'
                width='240px'
                open={this.state.showModal} 
                title='Edit Medication'
                data={this.state.record}
                content={medicationForm()}
                onDismiss={() => this.setState({showModal: false, record: null})}
            />
        )
    }

}


const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        medications : Object.values(state.medications),
        userId : state.auth.userId,
        selectedMedication : state.selectedMedication,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchMedications, fetchMedication, editMedication, newMedication, deleteMedication})(Medication);





